import { render, staticRenderFns } from "./FinanceReportsProfitAndLoss.vue?vue&type=template&id=6b767c33"
import script from "./FinanceReportsProfitAndLoss.vue?vue&type=script&lang=js"
export * from "./FinanceReportsProfitAndLoss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports